import { ContactDetails } from "../components/investment-robot/forecast-screen/email-me-modal/ForecastEmailMeCard";

export const validateContactDetailsInput = ( input: ContactDetails | undefined, isAdvisor:boolean) => {
    if (input === undefined){
        return false
    }

    return validateName(input.name)
        && validateEmail(input.email)
        && ( (input.phone === '' ? true : validatePhone(input.phone)) || ( input.phone === undefined ? true : validatePhone(input.phone)))
        && ( !input.advisorEmail || (isAdvisor === validateEmail(input.advisorEmail)) )
}

export function validateEmail(email: string) {
    var regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return regex.test(email);
}

export function validatePhone(phone: string) {
    var phone_number = /^([(,),\-,+]*[0-9]){10,}$/gm;
    return phone_number.test(phone);
}

export function validateName(name: string) {
    var regex = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
    return regex.test(name);
}